<template>
    <div class="tab-content-container">
        <div class="tab-header-container">
            <h2 class="form-label">Информация за автомобила</h2>
            <LiteButton @click.native="editButtonClicked"
                        class="edit-button"
                        v-show="!shouldEditOverallInfo"
                        :hoverColor="'blue'"
                        :icon="'far fa-edit'">
            </LiteButton>
            <LiteButton @click.native="editButtonClicked"
                        style="font-size: 27px;"
                        class="edit-button"
                        v-show="shouldEditOverallInfo"
                        :hoverColor="'red'"
                        :icon="'far fa-window-close'">
            </LiteButton>

            <div class="last-modified-container">
                <p class="last-modified-date" v-text="getCarInfoLastModifiedDate"></p>
                <p class="last-modified-name" v-text="getCarInfoLastModifiedBy"></p>
            </div>
        </div>

        <hr class="form-line">

        <!--    when preview    -->

        <!--     personal info       -->
        <div class="text-container" v-if="!shouldEditOverallInfo && !isCarLoading">
            <div class="form-column-container">
                <TextField class="text-field"
                           :label="'Регистрационен номер'"
                           :value="carInfoCache.registrationNumber">
                </TextField>

                <TextField class="text-field"
                           :label="'Марка'"
                           :value="carInfoCache.brand">
                </TextField>

                <TextField class="text-field"
                           :label="'Модел'"
                           :value="carInfoCache.model">
                </TextField>

                <TextField class="text-field"
                           :label="'Брой места'"
                           :value="carInfoCache.seats ?  + carInfoCache.seats + '' : ''">
                </TextField>

            </div>
            <div class="form-column-container">
                <TextField class="text-field"
                           :label="'Статус'"
                           :value="carInfoCache.status ? carInfoCache.status.name : ''">
                </TextField>

                <TextField class="text-field"
                           :label="'Тип'"
                           :value="carInfoCache.type ? carInfoCache.type.name : ''">
                </TextField>

                <TextField class="text-field"
                           :label="'Категория'"
                           :value="carInfoCache.category ? carInfoCache.category.name : ''">
                </TextField>

                <TextField class="text-field"
                           :label="'Данък'"
                           :value="carInfoCache.tax ? carInfoCache.tax + ' лв.' : ''">
                </TextField>
            </div>
        </div>

        <hr class="form-line" v-if="!shouldEditOverallInfo"/>

        <div class="text-container" v-if="!shouldEditOverallInfo && !isCarLoading">
            <div class="form-column-container" style="width: 70%">
                <TextField class="text-field"
                           :label="'Екип'"
                           :value="carInfoCache.team ? carInfoCache.team.name : '-'">
                </TextField>
            </div>
            <div class="form-column-container" style="width: 30%">
            </div>
        </div>

        <hr class="form-line" v-if="!shouldEditOverallInfo"/>

        <div class="text-container" v-if="!shouldEditOverallInfo && !isCarLoading">
            <div class="form-column-container" style="width: 70%">
                <TextField class="text-field"
                           :label="'Дата на следващ Технически Преглед'"
                           :value="formatDate(carInfoCache.nextTechnicalReview)">
                </TextField>

                <TextField class="text-field"
                           :label="'Дата на последно сервизно обслужване'"
                           :value="formatDate(carInfoCache.lastService)">
                </TextField>

                <TextField class="text-field"
                           :label="'Дата на следващо сервизно обслужване'"
                           :value="formatDate(carInfoCache.nextService)">
                </TextField>

                <TextField class="text-field"
                           :label="'Срок на валидност на застраховката'"
                           :value="formatDate(carInfoCache.insuranceExpiryDate)">
                </TextField>
            </div>

            <div class="form-column-container" style="width: 30%">
            </div>
        </div>

        <!--    when edit    -->
        <form class="form-container" v-if="shouldEditOverallInfo">
            <div class="form-column-container" v-if="isUserAdmin">
                <InputText class="input"
                           v-if="isUserAdmin"
                           @value-change="setAttribute"
                           :id="'registrationNumber'"
                           :name="'registrationNumber'"
                           :label="'Регистрационен номер'"
                           :placeholder="'Въведете регистрационен номер'"
                           :initialValue="carInfoCache.registrationNumber"
                           :showError="shouldShowError('registrationNumber')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('registrationNumber')"
                            :text="errors['registrationNumber']"/>

                <InputText class="input"
                           v-if="isUserAdmin"
                           @value-change="setAttribute"
                           :id="'brand'"
                           :name="'brand'"
                           :label="'Марка'"
                           :placeholder="'Въведете марка'"
                           :initialValue="carInfoCache.brand"
                           :showError="shouldShowError('brand')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('brand')" :text="errors['brand']"/>

                <InputText class="input"
                           v-if="isUserAdmin"
                           @value-change="setAttribute"
                           :id="'model'"
                           :name="'model'"
                           :label="'Модел'"
                           :placeholder="'Въведете модел'"
                           :initialValue="carInfoCache.model"
                           :showError="shouldShowError('model')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('model')" :text="errors['model']"/>

                <InputText class="input"
                           v-if="isUserAdmin"
                           @value-change="setAttribute"
                           :id="'seats'"
                           :name="'seats'"
                           :label="'Брой места'"
                           :isNumber="true"
                           :placeholder="'Въведете брой места'"
                           :initialValueNumber="carInfoCache.seats"
                           :showError="shouldShowError('seats')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('seats')" :text="errors['seats']"/>

            </div>
            <div class="form-column-container">
                <CarStatusDropdown class="input"
                                   :id="'statusDropdown'"
                                   :label="'Статус'"
                                   :defaultSelected="carInfoCache.status"
                                   @selection-change="statusSelected"/>


                <CarCategoryDropdown class="input"
                                     v-if="isUserAdmin"
                                     :id="'categoryDropdown'"
                                     :label="'Категория'"
                                     :defaultSelected="carInfoCache.category"
                                     @selection-change="categorySelected"/>

                <CarTypeDropdown class="input"
                                 v-if="isUserAdmin"
                                 :id="'typeDropdown'"
                                 :label="'Тип'"
                                 :defaultSelected="carInfoCache.type"
                                 @selection-change="typeSelected"/>

                <InputText class="input"
                           @value-change="setAttribute"
                           :id="'tax'"
                           :name="'tax'"
                           :label="'Данък'"
                           :isNumber="true"
                           :placeholder="'Въведете данък'"
                           :initialValueNumber="carInfoCache.tax"
                           :showError="shouldShowError('tax')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('tax')" :text="errors['tax']"/>
            </div>

            <hr class="form-line"/>

            <div class="form-container" v-if="shouldEditOverallInfo">
                <div class="form-column-container" style="width: 80%;">
                    <TeamDropdown class="input"
                                  :id="'teamDropdown'"
                                  :name="'teamDropdown'"
                                  :defaultSelected="carInfo.team"
                                  :label="'Екип'"
                                  @selection-change="teamSelected"
                    />
                </div>
                <div class="form-column-container" style="width: 20%;">
                </div>

                <hr class="form-line"/>

                <div class="form-container" v-if="shouldEditOverallInfo">
                    <div class="form-column-container" style="width: 80%;">
                        <label class="car-datepicker-label">Дата на следващ Технически Преглед</label>
                        <date-picker v-model="nextTechnicalReview"
                                     type="date"
                                     :format="'DD-MM-YYYY'"
                                     :lang="{formatLocale: getFormatLocale()}"
                                     class="input input-date"
                                     placeholder="Изберете дата"/>

                        <label class="car-datepicker-label">Дата на последно сервизно обслужване</label>
                        <date-picker v-model="lastService"
                                     type="date"
                                     :format="'DD-MM-YYYY'"
                                     :lang="{formatLocale: getFormatLocale()}"
                                     class="input input-date"
                                     placeholder="Изберете дата"/>

                        <label class="car-datepicker-label">Дата на следващо сервизно обслужване</label>
                        <date-picker v-model="nextService"
                                     type="date"
                                     :format="'DD-MM-YYYY'"
                                     :lang="{formatLocale: getFormatLocale()}"
                                     class="input input-date"
                                     placeholder="Изберете дата"/>

                        <label class="car-datepicker-label">Срок на валидност на застраховката</label>
                        <date-picker v-model="insuranceExpiryDate"
                                     type="date"
                                     :format="'DD-MM-YYYY'"
                                     :lang="{formatLocale: getFormatLocale()}"
                                     class="input input-date"
                                     placeholder="Изберете дата"/>
                    </div>
                    <div class="form-column-container" style="width: 20%;">
                    </div>

                    <hr class="form-line"/>

                    <Button class="save-button"
                            @click.native="saveCarInfo"
                            :color="'green'"
                            :text="'Запази'"
                            :icon="'fa fa-save'"></Button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import InputText from "@/shared/components/form/InputText";
    import ErrorInput from "@/shared/components/form/ErrorInput";
    import Button from "@/shared/components/button/Button";
    import LiteButton from "@/shared/components/button/LiteButton";
    import TextField from "@/shared/components/TextField";
    import mapperService from "@/services/mapper.service";
    import {cloneDeep} from 'lodash';
    import DatePicker from 'vue2-datepicker';
    import carService from "@/services/car.service";
    import dateService from "@/services/date.service";

    export default {
        name: "CarOverallInfo",
        components: {
            TextField,
            LiteButton,
            InputText,
            ErrorInput,
            Button,
            DatePicker
        },
        created() {
            this.carInfoCache = cloneDeep(this.carInfo);
            if (this.carInfoCache) {
                this.nextTechnicalReview = this.carInfoCache.nextTechnicalReview ? new Date(this.carInfoCache.nextTechnicalReview) : null;
                this.lastService = this.carInfoCache.lastService ? new Date(this.carInfoCache.lastService) : null;
                this.nextService = this.carInfoCache.nextService ? new Date(this.carInfoCache.nextService) : null;
                this.insuranceExpiryDate = this.carInfoCache.insuranceExpiryDate ? new Date(this.carInfoCache.insuranceExpiryDate) : null;
            }
        },
        data() {
            return {
                shouldEditOverallInfo: false,
                carInfoCache: cloneDeep(this.carInfo),
                errors: {},
                nextTechnicalReview: null,
                lastService: null,
                nextService: null,
                insuranceExpiryDate: null
            }
        },
        methods: {
            setAttribute(value) {
                this.carInfoCache[value.name] = value.currentValue;
                this.errors[value.name] = null;
            },
            shouldShowError(fieldName) {
                return !!(this.errors && this.errors[fieldName]);
            },
            teamSelected(event) {
                if (event.currentValueId) {
                    this.carInfoCache.team = {id: event.currentValueId};
                } else {
                    this.carInfoCache.team = null;
                }
            },
            categorySelected(event) {
                if (event.currentValue) {
                    this.carInfoCache.category = {enumName: event.currentValueId};
                } else {
                    this.carInfoCache.category = {enumName: null};
                }
            },
            typeSelected(event) {
                if (event.currentValue) {
                    this.carInfoCache.type = {enumName: event.currentValueId};
                } else {
                    this.carInfoCache.type = {enumName: null};
                }
            },
            statusSelected(event) {
                if (event.currentValue) {
                    this.carInfoCache.status = {enumName: event.currentValueId};
                } else {
                    this.carInfoCache.status = {enumName: null};
                }
            },
            editButtonClicked() {
                this.shouldEditOverallInfo = !this.shouldEditOverallInfo;
                this.carInfoCache = cloneDeep(this.carInfo);
            },
            formatDate(date) {
                if (date) {
                    return dateService.formatDate(date);
                }
                return '';
            },
            getFormatLocale() {
                return dateService.getFormatLocale();
            },
            saveCarInfo() {
                carService.updateCarInfo(this.carInfoCache)
                    .then(({data}) => {
                        this.$store.commit('setCarInfo', data);
                        this.shouldEditOverallInfo = false;
                    })
                    .catch((errors) => this.errors = errors.response.data.errors);
            }
        },
        computed: {
            ...mapGetters(['carInfo', 'isCarLoading', 'isUserAdmin']),

            getCarInfoLastModifiedBy() {
                return this.carInfoCache ? mapperService.getLastModifiedBy(this.carInfoCache) : '';
            },
            getCarInfoLastModifiedDate() {
                return this.carInfoCache ? mapperService.getLastModifiedDate(this.carInfoCache) : '';
            },
        },
        watch: {
            carInfo: {
                handler(newVal) {
                    if (newVal) {
                        this.carInfoCache = cloneDeep(newVal);
                        this.nextTechnicalReview = this.carInfoCache.nextTechnicalReview ? new Date(this.carInfoCache.nextTechnicalReview) : null;
                        this.lastService = this.carInfoCache.lastService ? new Date(this.carInfoCache.lastService) : null;
                        this.nextService = this.carInfoCache.nextService ? new Date(this.carInfoCache.nextService) : null;
                        this.insuranceExpiryDate = this.carInfoCache.insuranceExpiryDate ? new Date(this.carInfoCache.insuranceExpiryDate) : null;
                    }
                },
                deep: true
            },
            nextTechnicalReview: {
                handler(newVal) {
                    if (newVal) {
                        this.carInfoCache.nextTechnicalReview = dateService.formatDateISO(newVal);
                    } else {
                        this.carInfoCache.nextTechnicalReview = null;
                    }
                },
                deep: true
            },
            nextService: {
                handler(newVal) {
                    if (newVal) {
                        this.carInfoCache.nextService = dateService.formatDateISO(newVal);
                    } else {
                        this.carInfoCache.nextService = null;
                    }
                },
                deep: true
            },
            lastService: {
                handler(newVal) {
                    if (newVal) {
                        this.carInfoCache.lastService = dateService.formatDateISO(newVal);
                    } else {
                        this.carInfoCache.lastService = null;
                    }
                },
                deep: true
            },
            insuranceExpiryDate: {
                handler(newVal) {
                    if (newVal) {
                        this.carInfoCache.insuranceExpiryDate = dateService.formatDateISO(newVal);
                    } else {
                        this.carInfoCache.insuranceExpiryDate = null;
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .form-container {
        width: 100%;
        height: fit-content;
    }

    .form-column-container {
        width: 50%;
        padding: 20px 140px;
        margin: 0 auto;
        display: inline-grid;
        height: fit-content;
        box-sizing: border-box;
    }

    .input {
        height: 95px;
        margin: 20px auto 0 auto;
    }

    .car-datepicker-label {
        float: left;
        height: 30px;
        width: 100%;
        text-align: left;
        margin-left: 5px;
        font-size: 20px;
        color: var(--dark-grey);
    }

    .input-date {
        margin: 20px 0 0 0;
    }
</style>
